@if (annotation$ | async; as annotation) {
  <img
    class="preview-image"
    [src]="annotation.body.content.relatedPerspective.preview | fixImageUrl"
  />
  <div class="header" (click)="toggleVisibility()">
    <span class="ranking">{{ annotation.ranking }}</span>
    <span class="title">{{ annotation.body.content.title || ('No title' | translate) }}</span>
    <small>{{ (annotation.validated ? 'validated' : 'not validated') | translate }}</small>
  </div>
  <app-markdown-preview
    id="annotation-content"
    [data]="annotation.body.content.description || ('No description' | translate)"
  ></app-markdown-preview>
  <k-button-row justify="end" gap="4">
    @if (canUserEditAndDelete$ | async) {
      <k-button
        icon-button
        color="transparent"
        [tooltip]="'Edit annotation' | translate"
        (click)="toggleFullscreen('edit')"
        ><mat-icon>edit</mat-icon></k-button
      >
    }
    @if (canUserReorder$ | async) {
      <k-button icon-button color="transparent" class="reorder-button">
        <mat-icon>low_priority</mat-icon>
        <k-menu label="Reorder annotation">
          <k-menu-option (click)="reorderAnnotation.emit('first')"
            >Move to first position</k-menu-option
          >
          <k-menu-option (click)="reorderAnnotation.emit('last')"
            >Move to last position</k-menu-option
          >
          <k-menu-option (click)="reorderAnnotation.emit('one-up')">One position up</k-menu-option>
          <k-menu-option (click)="reorderAnnotation.emit('one-down')"
            >One position down</k-menu-option
          >
        </k-menu>
      </k-button>
    }
    <k-button
      icon-button
      color="transparent"
      [tooltip]="'Copy annotation to collection' | translate"
      (click)="shareAnnotation()"
      ><mat-icon>file_copy</mat-icon></k-button
    >
    <k-button icon-button color="transparent" [tooltip]="'Export annotation as JSON' | translate"
      ><mat-icon>file_download</mat-icon></k-button
    >
    <k-button
      icon-button
      color="transparent"
      [tooltip]="'Show in fullscreen view' | translate"
      (click)="toggleFullscreen('preview')"
      ><mat-icon>select_all</mat-icon></k-button
    >
    @if (isAnnotationHidden$ | async) {
      <k-button
        icon-button
        color="transparent"
        [tooltip]="'Show annotation' | translate"
        (click)="setVisibility(true)"
        ><mat-icon>visibility_off</mat-icon></k-button
      >
    } @else {
      <k-button
        icon-button
        color="transparent"
        [tooltip]="'Hide annotation' | translate"
        (click)="setVisibility(false)"
        ><mat-icon>visibility</mat-icon></k-button
      >
    }
    @if (canUserEditAndDelete$ | async) {
      <k-button
        icon-button
        color="transparent"
        [tooltip]="'Delete annotation' | translate"
        (click)="deleteAnnotation()"
        ><mat-icon>delete</mat-icon></k-button
      >
    }
  </k-button-row>
}

<!-- TODO: Figure out if we need any of the commented out features, e.g. set perspective -->
<!--
@if (annotation$ | async; as annotation) {
<mat-card appearance="outlined" class="annotation-card">
  <form class="annotation-form">
    <mat-card-header (click)="changeOpenPopup()">
      <div mat-card-avatar class="annotation-header-image">
        <span>{{ annotation.ranking }}</span>
      </div>
      <mat-card-title>
        @if (isEditMode$ | async) {
        <mat-form-field>
          <mat-label>{{ 'Title' | translate }}</mat-label>
          <input
            matInput
            name="title"
            #title="ngModel"
            type="text"
            [(ngModel)]="annotation.body.content.title"
          />
        </mat-form-field>
        } @else {
        <span>{{ annotation.body.content.title | uppercase }}</span>
        }
      </mat-card-title>
      <mat-card-subtitle>
        {{ (annotation.validated ? 'validated' : 'not validated') | translate }}
      </mat-card-subtitle>
    </mat-card-header>
    @if (previewImage$ | async; as previewImage) { @if (!(collapsed$ | async)) {
    <img mat-card-image [src]="previewImage" />
    } } @else {
    <p>{{ 'This annotation has no preview image' | translate }}</p>
    } @if (!(collapsed$ | async)) {
    <mat-card-content>
      @if (isEditMode$ | async) {
      <mat-form-field class="description">
        <textarea
          matInput
          #annotationContent
          cdkTextareaAutosize
          cdkAutosizeMinRows="1"
          name="description"
          type="text"
          placeholder="{{ 'Description' | translate }}"
          [(ngModel)]="annotation.body.content.description"
        ></textarea>
      </mat-form-field>
      @if (userOwnsCompilation$ | async) {
      <mat-checkbox
        class="validation"
        [checked]="annotation.validated"
        (change)="annotation.validated = !annotation.validated"
        >{{ 'Validated' | translate }}
      </mat-checkbox>
      }
      <button
        mat-stroked-button
        color="primary"
        (click)="selectPerspective()"
        tooltip="{{ 'Select Perspective' | translate }}"
        tooltipPosition="right"
        type="button"
        class="perspective"
      >
        <mat-icon [attr.aria-label]="'Select Perspective' | translate">camera</mat-icon>
        {{ 'Select Perspective' | translate }}
      </button>
      } @else {
      <app-markdown-preview
        id="annotation-content"
        [data]="annotation.body.content.description"
      ></app-markdown-preview>
      }
    </mat-card-content>
    }
    <mat-card-actions style="color: white">
      <mat-slide-toggle [checked]="showAnnotation$ | async" (change)="toggleVisibility()">
        {{ ((showAnnotation$ | async) ? 'Hide' : 'Show') | translate }}
      </mat-slide-toggle>
      @if ((processing.hasAnnotationAllowance$ | async) && (isAnnotationOwner$ | async)) {
      <k-button
        icon-button
        (click)="toggleEditViewMode()"
        [tooltip]="((isEditMode$ | async) ? 'Save annotation' : 'Edit annotation') | translate"
        tooltipPosition="above"
        type="button"
      >
        <mat-icon
          [attr.aria-label]="
            ((isEditMode$ | async) ? 'Save annotation' : 'Edit annotation') | translate
          "
        >
          {{ (isEditMode$ | async) ? 'save' : 'edit' }}
        </mat-icon>
      </k-button>
      <k-button
        icon-button
        (click)="editFullscreen()"
        tooltip="{{ 'Edit in Fullscreen Mode' | translate }}"
        tooltipPosition="above"
        type="button"
      >
        <mat-icon [attr.aria-label]="'Fullscreen' | translate">select_all</mat-icon>
      </k-button>
      <k-button
        icon-button
        (click)="deleteAnnotation()"
        tooltip="{{ 'Delete' | translate }}"
        tooltipPosition="above"
        type="button"
      >
        <mat-icon [attr.aria-label]="'Delete' | translate">delete</mat-icon>
      </k-button>
      } @if (annotation._id !== 'DefaultAnnotation') {
      <k-button
        icon-button
        (click)="shareAnnotation()"
        tooltip="{{ 'Copy to collection' | translate }}"
        tooltipPosition="above"
        type="button"
      >
        <mat-icon [attr.aria-label]="'Copy to collection' | translate">file_copy</mat-icon>
      </k-button>
      }
    </mat-card-actions>
  </form>
</mat-card>
}
-->
